function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import forIn from 'lodash/forIn';
import get from 'lodash/get';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import unset from 'lodash/unset';
import { AppContext } from 'context';
import { formatDateAsObject, formatObjectAsDate } from 'helpers/datetime';
import { foldObject, unfoldObject, compactObject } from 'helpers/transformers';
import Avatar from 'components/Avatar';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import FormContainerAbstract from 'components/FormContainerAbstract';
import TemplatedFields from 'components/TemplatedFields';
import templateFieldShape from 'shapes/templateFieldShape';
import App, { AvatarCropModal } from 'modules/App';
import Information from 'modules/Information';
import Validator from '../../AccountValidator';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import * as selectors from '../../selectors';
import messages from '../../messages';
import LegalConsents from '../../partials/LegalConsents';
import validatorRules from './validatorRules.json';
class InformationForm extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { consentsTemplate, information } = this.props;
        if (prevProps.information !== information && information) {
            this.onPopulateInformation();
        }
        if (prevProps.consentsTemplate !== consentsTemplate && consentsTemplate) {
            this.onSetValidatorRules();
        }
    }
    onPopulateInformation() {
        const { information, isEdit } = this.props;
        if (!isEdit || !information) {
            return;
        }
        let formValues = {};
        const pureInformation = omit(information, [
            'legalConsentApprovals'
        ]);
        formValues = foldObject(pureInformation);
        if (formValues.dateOfBirth) {
            formValues.dateOfBirth = formatDateAsObject(formValues.dateOfBirth);
        }
        this.props.onSetFormValues(formValues);
    }
    onAddValidatorRules(rules) {
        this.validatorRules = _object_spread({}, this.validatorRules, rules);
    }
    onSetValidatorRules() {
        this.legalConsentsFields = [];
        this.requiredRules = {};
        forEach([
            ...this.marketingConsents,
            ...this.privacyAndHealthData,
            ...this.sensitiveDataAndProfilingConsents
        ], (legalConsent)=>{
            const { legalConsentId, isMandatory } = legalConsent;
            const legalConsentFieldId = `legalConsent-${legalConsentId}`;
            this.legalConsentsFields.push(legalConsentFieldId);
            if (isMandatory) {
                this.validatorRules[legalConsentFieldId] = 'required, boolTrue';
                this.requiredRules[legalConsentFieldId] = 'required, boolTrue';
            } else {
                this.validatorRules[legalConsentFieldId] = 'bool';
            }
        });
    }
    onValidate(rules) {
        const values = _object_spread({}, get(this.props.formValues, 'values', {}));
        let dateOfBirth;
        if (values.dateOfBirth && values.dateOfBirth.year && values.dateOfBirth.month && values.dateOfBirth.day) {
            dateOfBirth = formatObjectAsDate(values.dateOfBirth);
        } else {
            dateOfBirth = '';
        }
        const { validatedValues, errors } = Validator.run(_object_spread_props(_object_spread({}, values), {
            dateOfBirth
        }), rules);
        return {
            validatedValues: unfoldObject(validatedValues),
            errors
        };
    }
    onSubmitAvatar(image) {
        this.props.onSetFormValue({
            id: 'avatar',
            value: image
        });
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const legalConsents = pick(validatedValues, this.legalConsentsFields);
            const legalConsentApprovals = [];
            forIn(legalConsents, (value, key)=>{
                const id = parseInt(key.split('-')[1], 10);
                legalConsentApprovals.push({
                    legalConsentId: id,
                    decision: value
                });
                unset(validatedValues, `legalConsent-${id}`);
            });
            validatedValues.legalConsentApprovals = legalConsentApprovals;
            this.props.onSubmit(compactObject(validatedValues));
        }
    }
    get filteredTemplate() {
        if (this.props.isEdit) {
            return this.props.informationTemplate;
        }
        const filteredTemplate = [];
        forEach(this.props.informationTemplate, (ft)=>{
            const value = get(this.props.information, ft.name);
            if (!value) filteredTemplate.push(ft);
        });
        return filteredTemplate;
    }
    get marketingConsents() {
        return filter(this.props.consentsTemplate, (consent)=>constants.COMMUNICATION_CONSENT_TYPES.includes(consent.type));
    }
    get privacyAndHealthData() {
        return filter(this.props.consentsTemplate, (consent)=>consent.type === 'PrivacyAndHealthData');
    }
    get sensitiveDataAndProfilingConsents() {
        return filter(this.props.consentsTemplate, (consent)=>consent.type === 'SensitiveDataAndProfiling');
    }
    renderActions() {
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-8",
            children: /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                className: "btn--block btn--filled",
                isDisabled: this.isDisabled,
                isInProgress: this.state.isInProgress,
                onClickDisabled: ()=>this.onCheck(),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.buttons.continue))
            })
        });
    }
    renderAvatar() {
        const { firstName, lastName } = this.props.information;
        const { avatar } = this.props.formValues ? this.props.formValues.values : {};
        return /*#__PURE__*/ _jsxs("div", {
            className: "pb-7",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--h2 mb-3",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.yourProfilePhoto))
                }),
                /*#__PURE__*/ _jsx(Avatar, {
                    id: "avatar",
                    avatarImg: avatar,
                    name: [
                        firstName,
                        lastName
                    ],
                    size: 80,
                    isEditable: true,
                    isRound: true,
                    onSetFormValue: this.props.onSetFormValue,
                    onFormErrors: this.props.onFormErrors
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx(TemplatedFields, {
                    template: this.filteredTemplate,
                    formValues: this.props.formValues,
                    messages: messages,
                    localizationResources: this.props.localizationResources,
                    validatorRules: this.validatorRules,
                    onAddValidatorRules: (rules)=>this.onAddValidatorRules(rules),
                    onSetFormValue: this.props.onSetFormValue,
                    onSetFormValues: this.props.onSetFormValues
                }),
                /*#__PURE__*/ _jsx(LegalConsents, {}),
                this.renderActions()
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("h1", {
                className: "text--h2",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.setInformation))
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderHeader(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pageContentBox",
                    children: [
                        this.renderAvatar(),
                        this.renderForm(),
                        /*#__PURE__*/ _jsx(AvatarCropModal, {
                            adjustHeaderMessage: messages.headers.avatarAdjust,
                            uploadHeaderMessage: messages.headers.avatarUpload,
                            isRound: true,
                            onImageSubmit: (image)=>this.onSubmitAvatar(image)
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
        this.requiredRules = {};
        this.legalConsentsFields = [];
        this.state = {
            isInProgress: false
        };
        this.onPopulateInformation();
        this.onSetValidatorRules();
    }
}
_define_property(InformationForm, "contextType", AppContext);
_define_property(InformationForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    information: PropTypes.object,
    isEdit: PropTypes.bool,
    identityProviderType: shapes.identityProviderType,
    // Implicit props
    informationTemplate: PropTypes.arrayOf(templateFieldShape),
    consentsTemplate: PropTypes.array,
    localizationResources: PropTypes.object,
    // Implicit actions
    onSetFormValue: PropTypes.func,
    onFormErrors: PropTypes.func
}));
const mapStateToProps = (state)=>({
        identityProviderType: selectors.identityProviderType(state),
        informationTemplate: Information.selectors.informationTemplate(state),
        consentsTemplate: Information.selectors.consentsTemplate(state),
        formValues: App.selectors.formSelector(constants.INFORMATION_FORM)(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.INFORMATION_FORM;
    return {
        onSubmit: (information)=>dispatch(Information.actions.sendInformation(information)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedInformationForm = connect(mapStateToProps, mapDispatchToProps)(InformationForm);
export default ConnectedInformationForm;
